import { render, staticRenderFns } from "./FormRO08.vue?vue&type=template&id=5d590977"
import script from "./FormRO08.vue?vue&type=script&lang=js"
export * from "./FormRO08.vue?vue&type=script&lang=js"
import style0 from "./FormRO08.vue?vue&type=style&index=0&id=5d590977&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports